module.exports = __webpack_public_path__ + "static/media/drop_down_arrow.71faf0e9.svg";